module.exports = __webpack_public_path__ + "static/img/3-leak-resend.d573cf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/3-leak-resend.png
// module id = 1331
// module chunks = 0